import { IOTV_SQSEvent, MapLike } from '@iotv/iotv-v3-types'
import { SQSEvent, SQSMessageAttributes, SQSRecord, SQSRecordAttributes } from '@iotv/iotv-v3-types'
import { v4 } from 'uuid'

export type MockSQSEventParams = {
  eventSourceARN?: string
}

export type GetSQSEventParams<T> = {
  /** the object that will be stringified into the SQS Event body as record at index 0,  */
  payload: T | T[]
  eventParams: Partial<MockSQSEventParams>
  SQSMessageAttributes?: SQSMessageAttributes
}

/** returns a sqs event with ONE record with its body as the stringified version of payload object */
export const getSQSEvent = <T extends MapLike<any>>({ payload, eventParams, SQSMessageAttributes }: GetSQSEventParams<T>) => {
  const recordPayloads = payload instanceof Array ? payload : [payload]

  const recordTemplate = {
    messageId: v4(),
    receiptHandle: 'r',

    body: '',
    attributes: {} as unknown as SQSRecordAttributes,

    messageAttributes: {},
    md5OfBody: '17',
    eventSource: 'aws:sqs',
    eventSourceARN: eventParams.eventSourceARN ?? 'arn:aws:sqs:ap-southeast-2:mockAccountId:mockEventSource',
    awsRegion: 'ap-southeast-2',
  }

  const template = {
    Records: [],
  } as SQSEvent

  for (let recordPayload of recordPayloads) {
    const record = { ...recordTemplate } as SQSRecord
    record.body = JSON.stringify(recordPayload)
    record.messageAttributes = SQSMessageAttributes ?? {}
    template.Records.push(record)
  }

  return template as IOTV_SQSEvent<T>
}
